<script setup lang="ts">
import { ref } from 'vue'
import { useAuthStore } from '../stores/auth'
import { apiPatch } from '../api/client'
import type { ApiError } from '../api/client'
import CInput from '../components/CInput.vue'
import CButton from '../components/CButton.vue'
import GFormErrors from '../components/GFormErrors.vue'

const auth = useAuthStore()

const displayName = ref(auth.user?.display_name ?? '')
const errors = ref<{ msg: string; path?: string }[]>([])
const saving = ref(false)

async function updateDisplayName() {
	errors.value = []
	saving.value = true

	try {
		const updated = await apiPatch<{ id: string; name: string; display_name: string }>(
			'/api/me',
			{ display_name: displayName.value }
		)
		if (auth.user) {
			auth.user.display_name = updated.display_name
		}
	} catch (e) {
		errors.value = (e as ApiError).errors ?? [{ msg: String(e) }]
	} finally {
		saving.value = false
	}
}
</script>

<template>
	<main class="l-row l-stack">
		<GFormErrors :errors="errors" />

		<h1>Your Profile</h1>

		<p>
			Hi, {{ auth.user?.display_name }}. There isn't a lot you can do here now, but you can change your display name. At some point, it will also be possible to view competitions you've entered into, stats, and vessels.
		</p>

		<form class="l-stack" @submit.prevent="updateDisplayName">
			<h2>Change your display name</h2>

			<p>
				Please note that while you can set your display name to whatever you like, we also store your current Discord name
				(currently <strong>{{ auth.user?.name }}</strong>) separately, so we can contact you if there's a problem with your submission.
			</p>

			<div class="l-flex">
				<CInput v-model="displayName" type="text" name="display_name" title="Display Name" :wide="true" />
				<CButton type="submit" :disabled="saving">Change name</CButton>
			</div>
		</form>

		<form class="l-stack" @submit.prevent="auth.signOut()">
			<h2>Sign Out</h2>
			<p>Bye! We'll see you soon!</p>
			<CButton type="submit">Sign Out</CButton>
		</form>
	</main>
</template>
